// extracted by mini-css-extract-plugin
export var carrierTab = "_4g-0";
export var carrierTabActive = "_4g-1 _4g-0";
export var carrierTabInactive = "_4g-2 _4g-0";
export var carrierTabLabel = "_4g-3";
export var carrierTabLabelActive = "_4g-4 _4g-3";
export var carrierTabLabelInactive = "_4g-5 _4g-3";
export var carrierTabPercentage = "_4g-6";
export var carrierTabPercentageActive = "_4g-7 _4g-6";
export var carrierTabPercentageInactive = "_4g-8 _4g-6";
export var carrierTabWinnable = "_4g-9";
export var carrierTabWinnableActive = "_4g-a _4g-9";
export var carrierTabWinnableInactive = "_4g-b _4g-9";
export var comparisonContainer = "_4g-d";
export var missingRateButton = "_4g-n";
export var missingRateButtonActive = "_4g-o _4g-n";
export var missingRateButtonInactive = "_4g-p _4g-n";
export var missingRateButtonLabel = "_4g-q";
export var missingRateButtonLabelActive = "_4g-r _4g-q";
export var missingRateButtonLabelInactive = "_4g-s _4g-q";
export var sidebar = "_4g-c";
export var strategyButton = "_4g-e";
export var strategyButtonActive = "_4g-f _4g-e";
export var strategyButtonDescription = "_4g-k";
export var strategyButtonDescriptionActive = "_4g-l _4g-k";
export var strategyButtonDescriptionInactive = "_4g-m _4g-k";
export var strategyButtonInactive = "_4g-g _4g-e";
export var strategyButtonLabel = "_4g-h";
export var strategyButtonLabelActive = "_4g-i _4g-h";
export var strategyButtonLabelInactive = "_4g-j _4g-h";
export var unitToggleButton = "_4g-t";
export var unitToggleButtonActive = "_4g-u _4g-t";
export var unitToggleButtonInactive = "_4g-v _4g-t";
export var unitToggleButtonLabel = "_4g-w";
export var unitToggleButtonLabelActive = "_4g-x _4g-w";
export var unitToggleButtonLabelInactive = "_4g-y _4g-w";